export class ElementModel {
  public code: string | null;
  public codeUnspecifiedFlag = false;

  public col2BufferValue: number;
  public col2Group: string;
  public col2Info: string | null;
  public col2Label: string | null;
  public col2ProgressValue: number;
  public col2SubGroup: string;
  public col3Group: string;
  public col3Label: string | null;
  public containerLabel: string | null | undefined;
  public disabledFlag: boolean;
  // firstSerialNumberFlag: indicates if the selected element is the first one of the selection.
  // it's used to set the focus on the first element of the selection when multiple selection.
  public firstSerialNumberFlag = false;
  public hat: string;
  public hatDisabledFlag: boolean;
  public hatStyle: 'accent' | 'accent-border' | 'primary' | 'primary-border' = 'accent';
  public hatWidth: 'auto' | 'fixed' = 'fixed';
  public highlightHatFlag: boolean;
  public key: string | null | undefined;
  public label: string | null | undefined;
  public labelUnspecifiedFlag = false;
  public subcontainerLabel: string | null | undefined;

  public constructor(
    code: string | null,
    containerLabel: string | null | undefined,
    key: string | null | undefined,
    label: string | null | undefined,
    subcontainerLabel: string | null | undefined,
  ) {
    this.code = code;
    this.containerLabel = containerLabel;
    this.key = key;
    this.label = label;
    this.subcontainerLabel = subcontainerLabel;
  }
}
